import { useState } from "react";

import { NotificationExpandToggle } from "./NotificationExpandToggle";
import { Column, Text } from "@/components";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { getCandidacyLink } from "@/lib/notificationLinks";
import { cn } from "@/lib/utils";
import { NotificationMissingStartDatesPayload, NotificationType } from "@/types";

export const NotificationMissingStartDatesList = ({
  isCompact = false,
  payload,
  trackingSurface,
}: {
  isCompact?: boolean;
  payload: NotificationMissingStartDatesPayload;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { placements } = payload;

  const render = () => (
    <Column className="gap-0.5">
      <NotificationExpandToggle
        isExpanded={isExpanded}
        notificationType={NotificationType.MISSING_START_DATES}
        setIsExpanded={setIsExpanded}
        trackingSurface={trackingSurface}
      >
        {placements.length}{" "}
        {placements.length === 1 ? "placement" : "placements"}
      </NotificationExpandToggle>
      {isExpanded ? (
        <Column className="gap-1 border-l border-slate-200 pl-3 pt-1">
          {placements.map((placement) => (
            <Column
              key={placement.candidacyId}
              className="cursor-pointer gap-0 rounded-md px-2 py-1.5 hover:bg-slate-50"
              onClick={(e) => {
                e.stopPropagation();
                mixpanelUtils.trackRowClick(
                  "Notification list item",
                  MIXPANEL_SCREENS.NOTIFICATIONS,
                  {
                    notification_type: NotificationType.MISSING_START_DATES,
                    surface: trackingSurface,
                  },
                );
                window.open(getCandidacyLink(placement), "_blank");
              }}
            >
              <Text className={cn("text-sm", isCompact && "text-xs")}>
                {placement.candidateName}
              </Text>
              <Text className="text-xs font-normal text-slate-500">
                {placement.customerName} &middot; {placement.reqTitle}
              </Text>
            </Column>
          ))}
        </Column>
      ) : null}
    </Column>
  );

  return render();
};
